import { SectionHeadline } from '@/components/SectionHeadline';
import { FloatingBoxProps, FloatingBoxes } from '@/components/boxes';
import { Button } from '@/components/buttons';
import { ContentContainer } from '@/components/layout';
import { Text } from '@/components/typography';
import React, { ReactNode } from 'react';
import { mergeClasses } from '@/utils/style';

export type BoxWithImage = {
	image: { alt: string; src: string };
	videoUrl?: never; // 'image' is present, so 'videoUrl' must be absent
};

export type BoxWithVideo = {
	image?: never; // 'videoUrl' is present, so 'image' must be absent
	videoUrl: string;
};

export type Boxes = Array<Omit<FloatingBoxProps, 'image'> & (BoxWithImage | BoxWithVideo)>;

function Floating({
	boxes,
	button,
	title,
	subtitle,
	bgCircles,
	headerClassName,
	footer,
	anchorKey = 'floating.title',
}: {
	boxes: Boxes;
	button?: {
		analyticsParam: string;
		testId: string;
		to: string;
		text: string;
	};
	title: string;
	subtitle?: string;
	bgCircles?: ReactNode;
	footer?: ReactNode;
	headerClassName?: string;
	anchorKey?: string;
}): React.JSX.Element {
	return (
		<div className="4xl:px-16 2xl:px-7">
			<div className="relative w-full overflow-hidden rounded-3xl bg-blue-900 px-4 pt-10 pb-14 text-white md:px-8 md:pb-16 lg:px-12 lg:pt-[7.5rem] lg:pb-20 2xl:m-auto">
				<ContentContainer className="relative z-10">
					<div className={mergeClasses('mx-auto mb-6 max-w-[48rem] lg:mb-12', headerClassName)}>
						<SectionHeadline className="m-0" variant="inverted" anchorKey={anchorKey}>
							{title}
						</SectionHeadline>
						{subtitle && (
							<Text className="text-light-gray-100 mt-4 text-center lg:mt-6" variant="p2">
								{subtitle}
							</Text>
						)}
					</div>
					<FloatingBoxes boxes={boxes} />
					{button && (
						<Button
							to={button.to}
							testId={button.testId}
							analyticsParam={button.analyticsParam}
							size="lg"
							variant="primary"
							align="center"
							className="mt-8 md:mt-12"
						>
							{button.text}
						</Button>
					)}
					{footer}
				</ContentContainer>
				{bgCircles}
			</div>
		</div>
	);
}

export default Floating;
